import { parseCookies, destroyCookie } from 'nookies';

import { ICookies, ITokens } from './types';

const STORAGE_TOKENS_KEY = 'tokens';

/**
 * LocalStorage tokens getter
 * return tokens if they exist in LocalStorage
 */
export const getTokensFromStorage = (): Partial<
  Omit<ITokens, 'expires_in'>
> | null => {
  const cookies: ICookies = parseCookies();
  return cookies.refresh_token || cookies.access_token
    ? {
        access_token: cookies.access_token,
        refresh_token: cookies.refresh_token,
      }
    : null;
};

/**
 * return Object with Authorization header or empty object if there is no access token in storage
 */
export const getHTTPAuthHeaders = (): { Authorization?: string } => {
  const { access_token } = getTokensFromStorage() || {};

  return access_token ? { Authorization: `Bearer ${access_token}` } : {};
};

/**
 * removes tokens from storage
 */
export const removeTokensFromStorage = (): void => {
  destroyCookie(null, 'access_token');
  destroyCookie(null, 'refresh_token');
  localStorage.removeItem(STORAGE_TOKENS_KEY);
};
